import {
  LoadAgenciesRequestAction,
  LoadAgenciesSuccessAction,
  LoadAgenciesErrorAction,
  LoadAllAvailableAgenciesErrorAction,
  LoadAllAvailableAgenciesSuccessAction,
  LoadAllAvailableAgenciesRequestAction,
  ProcessActionRequestAction,
  ClearStoreAction,
} from './actions.d';
import actionsTypes from './actionTypes';
import { ILoadDataRequestPayload, ILoadDataSuccessPayload, IProcessRequestPayload } from './types.d';

const actions = {
  loadAgenciesRequest: <T1, T2>(payload: ILoadDataRequestPayload<T1, T2>): LoadAgenciesRequestAction<T1, T2> => ({
    type: actionsTypes.LOAD_AGENCIES_REQUEST,
    payload,
  }),

  loadAgenciesSuccess: (payload: ILoadDataSuccessPayload): LoadAgenciesSuccessAction => ({
    type: actionsTypes.LOAD_AGENCIES_SUCCESS,
    payload,
  }),

  loadAgenciesError: (): LoadAgenciesErrorAction => ({
    type: actionsTypes.LOAD_AGENCIES_ERROR,
  }),

  loadAllAvailableAgenciesRequest: <T1, T2>(
    payload: ILoadDataRequestPayload<T1, T2>,
  ): LoadAllAvailableAgenciesRequestAction<T1, T2> => ({
    type: actionsTypes.LOAD_ALL_AVAILABLE_AGENCIES_REQUEST,
    payload,
  }),

  loadAllAvailableAgenciesSuccess: (payload: ILoadDataSuccessPayload): LoadAllAvailableAgenciesSuccessAction => ({
    type: actionsTypes.LOAD_ALL_AVAILABLE_SUCCESS,
    payload,
  }),

  loadAllAvailableAgenciesError: (): LoadAllAvailableAgenciesErrorAction => ({
    type: actionsTypes.LOAD_ALL_AVAILABLE_ERROR,
  }),

  processActionRequest: <T1, T2>(payload: IProcessRequestPayload<T1, T2>): ProcessActionRequestAction<T1, T2> => ({
    type: actionsTypes.PROCESS_ACTION_REQUEST,
    payload,
  }),

  clearStore: (): ClearStoreAction => ({
    type: actionsTypes.CLEAR_STORE,
  }),
};

export default actions;
